export default "__VITE_ASSET__D20Mayuk__"